import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
//________________________________________________________________________________________________________________________________________________
//This service handles the assignment of the ids for the docked and floating panes 
//It also serves that purpose for all the floating panes along the different layouts by using the local storage
//________________________________________________________________________________________________________________________________________________
export class IdService {
  private idCounter: number;
  private defaultPaneCount: number;

  constructor() {
    this.idCounter = this.getFromLocalStorage('idCounter', 0);
    //Initial docked panes are 6 and have to be 6, changing this will require you to change all occurences of this.
    //It is done this was as it was mentioned that 6 will not be changing 
    this.defaultPaneCount = this.getFromLocalStorage('defaultPaneCount', 6);
  }

  private getFromLocalStorage(key: string, defaultValue: number): number {
    const storedValue = localStorage.getItem(key);
    return storedValue !== null ? parseInt(storedValue, 10) : defaultValue;
  }

  private setToLocalStorage(key: string, value: number): void {
    localStorage.setItem(key, value.toString());
  }

  generateId(prefix: string): string {
    this.idCounter++;
    this.setToLocalStorage('idCounter', this.idCounter);
    return `${prefix}${this.idCounter}`;
  }

  generateFloatingId(floatingPanePrefix: string): string {
    this.defaultPaneCount++;
    this.setToLocalStorage('defaultPaneCount', this.defaultPaneCount);
    return `${floatingPanePrefix}${this.defaultPaneCount}`;
  }

  revertLastGeneratedFloatingId(): void {
    this.defaultPaneCount--;
    this.setToLocalStorage('defaultPaneCount', this.defaultPaneCount);
  }
}